import type { FC, ReactNode } from 'react'

import styles from './ehrAppointmentV2.module.scss'

type Props = {
  title: string
  chartLink: ReactNode | null
}

export const DialogHeader: FC<Props> = ({ title, chartLink }) => (
  <div className={styles.header}>
    <h2 className={styles.headerTitle}>{title}</h2>
    {chartLink}
    <span className={styles.headerSpacer} />
  </div>
)
